import { useNavigate } from 'react-router-dom'

import useQuery from '../../context/useQuery'

export const receivedListParam = 'received'
export const PAGE_SIZE = 10

export const isReceivedList = (params: URLSearchParams) => params.get('list') === receivedListParam

export const listPage = (params: URLSearchParams, name: string) => {
  const requested = Number(params.get(name) ?? 1)
  return Number.isFinite(requested) && requested >= 1 ? Math.floor(requested) : 1
}

export const toBeEmailedUrl = (page: number) =>
  `/api/admin/users/to-be-emailed?page=${page}&limit=${PAGE_SIZE}`

export const alreadyReceivedUrl = (page: number) =>
  `/api/admin/users/already-received?page=${page}&limit=${PAGE_SIZE}`

type ListName = 'to-be-emailed' | 'received'

type Props = {
  selected: ListName
  toBeEmailedLabel: string
  alreadyReceivedLabel: string
}

const FirstInvoiceTabs = ({ selected, toBeEmailedLabel, alreadyReceivedLabel }: Props) => {
  const params = useQuery()
  const navigate = useNavigate()

  const select = (next: ListName) => {
    const query = new URLSearchParams(params)
    if (next === 'received') query.set('list', receivedListParam)
    else query.delete('list')
    const search = query.toString()
    navigate(search ? `/admin?${search}` : '/admin')
  }

  return (
    <ul className="nav nav-tabs" role="tablist">
      <li className="nav-item" role="presentation">
        <button
          type="button"
          className={`nav-link ${selected === 'to-be-emailed' ? 'active' : ''}`}
          role="tab"
          aria-selected={selected === 'to-be-emailed'}
          onClick={() => select('to-be-emailed')}
        >
          {toBeEmailedLabel}
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          type="button"
          className={`nav-link ${selected === 'received' ? 'active' : ''}`}
          role="tab"
          aria-selected={selected === 'received'}
          onClick={() => select('received')}
        >
          {alreadyReceivedLabel}
        </button>
      </li>
    </ul>
  )
}

export default FirstInvoiceTabs
